import React, { useState, useRef } from "react";
import styled from "styled-components";
import { navigate } from "@reach/router";
import { View, Text, Link, Divider, Icon } from "./components";
import scrollIntoView from "scroll-into-view-if-needed";
import smoothScrollIntoView from "smooth-scroll-into-view-if-needed";
import friendlyUrl from "slug";

const scrollIntoViewSmoothly =
  "scrollBehavior" in document.documentElement.style
    ? scrollIntoView
    : smoothScrollIntoView;

export const MaxHeightContainer = styled(View)`
  max-height: 0;
  overflow-y: hidden;
  transition: max-height 250ms ease;
  ${({ on }) =>
    !on &&
    `
  & * {
    pointer-events: none;
  }
  `}
`;

export const RotateIcon = styled(Icon)`
  transform-origin: 50% 50%;
  transform: rotate(${({ rotate }) => (rotate ? `90deg` : `180deg`)});
  transition: transform 250ms ease;
`;

const ClickArea = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: transparent;
`;

const Category = ({ name, artists, activeCategory, setActiveCategory }) => {
  // const { on, toggle, reset } = useToggle(false)
  const on = activeCategory === name;
  const el = useRef(null);

  const scroll = () => {
    setTimeout(() => {
      scrollIntoViewSmoothly(el.current, {
        behavior: "smooth",
        scrollMode: "if-needed",
        block: "center",
        inline: "center",
      });
    }, 500);
  };

  return (
    <div ref={el}>
      <Text style={{ position: "relative" }}>
        {name}
        <ClickArea
          onClick={() => {
            if (name === activeCategory) {
              navigate("/artists/" + friendlyUrl(activeCategory));
            } else {
              setActiveCategory(name !== activeCategory && name);
              scroll();
            }
          }}
        />
        <RotateIcon
          icon="arrow"
          size={14}
          style={{ float: "right" }}
          rotate={on}
          onClick={() => {
            setActiveCategory(name !== activeCategory && name);
          }}
        />
      </Text>
      <MaxHeightContainer
        style={{ ...(on && { maxHeight: 24 + artists.length * 24 }) }}
        on={on}
      >
        {artists.map((artist, index) => (
          <Link
            block
            to={`/artist/${artist.slug.split("-bio")[0]}`}
            mb={index === artists.length - 1 ? 2 : 2}
            mt={index === 0 ? 3 : 2}
            textStyle="label"
            key={index}
          >
            {artist.title.split("Volkers").join("Völkers").split(" - ")[0]}
          </Link>
        ))}
      </MaxHeightContainer>
      <Divider />
    </div>
  );
};

export default ({ artistsByCategory }) => {
  const [activeCategory, setActiveCategory] = useState(null);
  return (
    <View mb={6}>
      <Divider />
      {artistsByCategory.map((category) => (
        <Category
          name={category.name}
          key={category.name}
          artists={category.artists}
          {...{ activeCategory, setActiveCategory }}
        />
      ))}
    </View>
  );
};
